import utils from '@bigcommerce/stencil-utils';

export const getPageContext = async (url) => new Promise((resolve, reject) => {
    utils.api.getPage(
        url,
        { template: 'ob-custom/common/ob-page-context' },
        (err, response) => {
            if (err) {
                return reject(err);
            }

            try {
                const data = JSON.parse(response);
                resolve(data);
            } catch (error) {
                const newError = new Error('Could not parse response JSON');
                newError.response = response;
                newError.error = error;
                return reject(newError);
            }
        },
    );
});

export const getCartContent = async (options) =>
    new Promise((resolve, reject) => {
        utils.api.cart.getContent(options, (err, response) => {
            if (err) {
                reject(err);
            }

            resolve(response);
        });
    });

export const addItem = (formData) =>
    new Promise((resolve, reject) => {
        utils.api.cart.itemAdd(formData, (err, response) => {
            const error = err || response.data.error;

            if (error) {
                return reject(error);
            }
            resolve(response);
        });
    });

export const removeCartItem = async (itemId) =>
    new Promise((resolve, reject) => {
        utils.api.cart.itemRemove(itemId, (err, response) => {
            if (err) {
                reject(err);
            }

            if (response?.data?.status === 'succeed') {
                resolve(response);
            }

            reject(response);
        });
    });

export const updateCartItem = async (itemId, quantity) =>
    new Promise((resolve, reject) => {
        utils.api.cart.itemUpdate(itemId, quantity, (err, response) => {
            if (err) {
                reject(err);
            }

            if (response.data.status === 'succeed') {
                resolve(response);
            }

            reject(response);
        });
    });

export const applyCoupon = async (couponCode) =>
    new Promise((resolve, reject) => {
        utils.api.cart.applyCode(couponCode, (err, response) => {
            if (err) {
                reject(err);
            }

            if (response?.data?.status === 'success') {
                resolve(response);
            }

            reject(response);
        });
    });

export const removeCoupon = async (couponId) => {
    const url = `/cart.php?action=removecoupon&couponid=${couponId}`;
    await getPageContext(url);
};

export const applyGiftCertificate = async (giftCertificateCode) =>
    new Promise((resolve, reject) => {
        utils.api.cart.applyGiftCertificate(giftCertificateCode, (err, response) => {
            if (err) {
                reject(err);
            }

            if (response?.data?.status === 'success') {
                resolve(response);
            }

            reject(response);
        });
    });

export const removeGiftCertificate = async (giftCertificateId) => {
    const url = `/cart.php?action=removegiftcertificate&giftcertificateid=${giftCertificateId}`;
    await getPageContext(url);
};

export const getCart = async () => new Promise((resolve, reject) => {
    utils.api.cart.getCart({}, (err, response) => {
        if (err) {
            reject(err);
        }

        resolve(response);
    });
});

export default {
    getCartContent,
    removeCartItem,
    updateCartItem,
    applyCoupon,
    applyGiftCertificate,
    removeCoupon,
    getCart,
};
